<template>
      <span style="cursor:pointer;" @click="openMyAvatarDetailModal()" v-if="type === 'hair'">{{ MyAvatarDetail.hair }}</span>
    <span style="cursor:pointer;" @click="openMyAvatarDetailModal()" v-if="type === 'clothes'">{{ MyAvatarDetail.clothes }}</span>
    <span style="cursor:pointer;" @click="openMyAvatarDetailModal()" v-if="type === 'weapon'">{{ MyAvatarDetail.weapon }}</span>
    <span style="cursor:pointer;" @click="openMyAvatarDetailModal()" v-if="type === 'shoes'">{{ MyAvatarDetail.shoes }}</span>
    <span style="cursor:pointer;" @click="openMyAvatarDetailModal()" v-if="type === 'pet'">{{ MyAvatarDetail.pet }}</span>
    <span style="cursor:pointer;" @click="openMyAvatarDetailModal()" v-if="type === 'face'">{{ MyAvatarDetail.face }}</span>

  <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId" v-if="active">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="editModalLabel">아바타 아이템 상세</h5>
        </div>
        <div class="modal-body">
          <table class="table">
            <tbody>
              <tr>
                <th>아이템번호</th>
                <td style="text-align:center;">{{Tsub.detail[type].id}}</td>
                <th>아이템코드</th>
                <td style="text-align:center;">{{Tsub.detail[type].inteCode}}</td>
              </tr>
              <tr>
                <th>아이템타입</th>
                <td style="text-align:center;">{{Tsub.detail[type].type}}</td>
                <th>아이템성별</th>
                <td style="text-align:center;">{{Tsub.detail[type].allowedGender}}</td>
              </tr>
              <tr>
                <th>아이템등급</th>
                <td style="text-align:center;">{{Tsub.detail[type].tier}}</td>
                <th>아이템명</th>
                <td style="text-align:center;">{{Tsub.detail[type].name}}</td>
              </tr>
              <tr>
                <th>상세설명</th>
                <td style="text-align:center;" colspan="3">{{Tsub.detail[type].description}}</td>
              </tr>
              <tr>
                <th>사용기간</th>
                <td style="text-align:center;" colspan="3">{{Tsub.detail[type].buyDate}} ~ {{Tsub.detail[type].expireDate}} 
                  ({{ Tsub.detail[type].expireDate 
                    ? (Tsub.detail[type].datPeriod > 0 
                        ? Tsub.detail[type].datPeriod + '일 남음)' 
                        : '종료)') 
                    : '무제한)' }}
                </td>
              </tr>
              <tr>
                <th>구매금액</th>
                <td style="text-align:center;">
                  {{ Tsub.detail[type].eventchk != 'event' 
                    ? (Tsub.detail[type].buyPrice === 'Event' 
                        ? 'Event' 
                        : (Tsub.detail[type].period === -1 
                            ? Tsub.detail[type].buyPrice + 'C (무제한)' 
                            : Tsub.detail[type].buyPrice + 'C (' + Math.floor(Tsub.detail[type].period / 86400) + ' 일)')) 
                    : 'event' }}
                </td>

                <th>유/무료</th>
                <td style="text-align:center;">
                  {{ Tsub.detail[type].eventchk === 'event' ? '무료' : Tsub.detail[type].buyPrice === 'Event' ? '무료' : '유료' }}
                </td>
              </tr>
              <tr> 
                <td colspan="4" style="text-align:center;">
                  <img :src="'https://avatar.useschool.co.kr/avatar/img/item/' + Tsub.detail[type].type + '/' + Tsub.detail[type].inteCode + '.png'" class="items" style="width:30%">
                </td>
              </tr>
            </tbody>
          </table>
          <div class="flex_center">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "MyAvatarDetail",
  props: {
    MyAvatarDetail: {
      type: Object,
      required: true,
      default: () => ({})
    },
    type: {
      type: String,
      required: true, // 'hair', 'clothes', 'weapon', 'shoes', 'pet', 'face' 등을 전달
    },
    btnId: String
  },
  data() {
    return {
      TbtnId: this.btnId || Math.random().toString().substr(2, 5),
      creating: false,
      active: false,
      avatarSrc: 'https://study.useschool.co.kr/img/main/sample_avatar.png', // 기본 아바타 이미지
      Tsub: {
        name: "",
        username: "",
        id: "",
        gender: "",
        hair: "",
        hair_name: "",
        clothes: "",
        clothes_name: "",
        weapon: "",
        weapon_name: "",
        shoes: "",
        shoes_name: "",
        pet: "",
        pet_name: "",
        face: "",
        face_name: "",
        nextBoxOpen: ""
      },
      changedData: {}
    };
  },
  methods: {
    nvl(str, altStr) {
      if (typeof str === "undefined" || str === null) str = altStr;
      return str;
    },
    fetchAvatarItem() {
      var extras = "";
      this.levelRequest.record = {};
      axios.get('/avatar/itemDetail/?student=' + this.Tsub.id).then((response) => {
        if (response.data.error) {
          $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
        } else {
          this.subscriptions = response.data.result;
          if(response.data.length){
          this.extendRequest.record = response.data.result[0];
          this.levelRequest.record = response.data.result[0];
          this.fetchProducts(response.data.result[0])
          this.extendRequest.payMethod = this.extendRequest.record.paymentMethod
          } else {
            this.fetchProducts()
          }

        }


      })
    },
    openMyAvatarDetailModal() {
      this.active = true;
      this.modifyMode(this.MyAvatarDetail);
      this.$nextTick(function () {
        var modalDom = document.getElementById("Modal" + this.TbtnId);
        var modal = bootstrap.Modal.getOrCreateInstance(modalDom);
        modalDom.addEventListener('hidden.bs.modal', (event) => {
          this.active = false;
        });
        modal.show();
      });
      // this.fetchAvatarItem()
    },
    modifyMode(record) {
      this.creating = false;
      this.changedData = {};
      this.Tsub = { ...record };
    },
  },
  mounted() {
    this.Tsub = this.MyAvatarDetail;
  },
  watch: {
    MyAvatarDetail() {
      this.Tsub = this.MyAvatarDetail;
    }
  }
};
</script>
